import { SET_SEARCH_TEXT } from "src/actions/type";

export const setSearchText = (text) => (dispatch) => {
  dispatch({ type: SET_SEARCH_TEXT, payload: text });
};
